import { type IInitialEvent, sendEventInvalidForm } from 'shared/lib/sendGAEvents';

import { selectAllFormFields, sendStepsAnalyticsEvents, setFormIsOpenedInPopupByStepId } from 'entities/creditForm';

import { AdditionalInfoTexts } from 'features/UpdateAdditionalInfo';
import { ContactsInfoTexts } from 'features/UpdateContactsInfo';
import { CreditPurposeInfoTexts } from 'features/UpdateCreditPurposeInfo';
import { PassportInfoTexts } from 'features/UpdatePassportInfo';
import { WorkplaceInfoTexts } from 'features/UpdateWorkplaceInfo';

import type { TStepsValidateErrors } from 'widgets/AnketaWidget/lib/validateUserDataThunk';

export const validateErrorHandlerThunk =
  (
    errors: TStepsValidateErrors,
    steps: Array<TStepsValidateErrors[0]['formStepId']>,
    analyticsOverrides?: Partial<Pick<IInitialEvent, 'event' | 'eventCategory'>>,
  ): ThunkResult<void> =>
  async (dispatch, getState) => {
    const formFields = selectAllFormFields(getState());

    errors.sort((a, b) => steps.indexOf(a.formStepId) - steps.indexOf(b.formStepId));

    const firstError = errors[0];
    const firstStepWithErrorIndex = steps.indexOf(firstError.formStepId);

    dispatch(setFormIsOpenedInPopupByStepId({ stepId: firstError.formStepId, isOpened: true }));

    dispatch(
      sendStepsAnalyticsEvents(
        Array.from({ length: firstStepWithErrorIndex }, (_, i) => i),
        {
          ...CreditPurposeInfoTexts,
          ...ContactsInfoTexts,
          ...PassportInfoTexts,
          ...WorkplaceInfoTexts,
          ...AdditionalInfoTexts,
        },
        'auto',
        analyticsOverrides,
      ),
    );

    const firstErrorFieldName = firstError.errorFields[0];
    sendEventInvalidForm(
      firstStepWithErrorIndex + 1,
      'auto',
      firstErrorFieldName,
      String(formFields[firstErrorFieldName]),
      analyticsOverrides,
    );
  };
